import Vue from 'vue'
import Router from 'vue-router'


//解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', redirect: '/show' },
    {
      path: '/container',
      mame:'container',
      component: () => import('@/views/Container'),
      children:[

        { path: '/welcome', name:'welcome', component: () => import('./views/welcome.vue') },
        // 就业扶贫管理系统
        { path: '/form_gyxjdbfzb', name:'form_gyxjdbfzb', component: () => import('./views/form_1/Form_gyxjdbfzb.vue') },
        { path: '/form_jyfpjd', name:'form_jyfpjd', component: () => import('./views/form_1/Form_jyfpjd.vue') },
        { path: '/form_pkhxx', name:'form_pkhxx', component: () => import('./views/form_1/Form_pkhxx.vue') },
        { path: '/helpInfo', name:'helpInfo', component: () => import('./views/form_1/helpInfo.vue') },

        // 数据分类采集系统
        { path: '/Form_grxxcj', name:'Form_grxxcj', component: () => import('./views/form_2/Form_grxxcj.vue') },
        { path: '/form_gwxxgxqkb', name:'form_gwxxgxqkb', component: () => import('./views/form_2/Form_gwxxgxqkb.vue') },
        { path: '/form_axdw', name:'form_axdw', component: () => import('./views/form_2/Form_axdw.vue') },
        { path: '/form_dlgkbb', name:'form_dlgkbb', component: () => import('./views/form_2/Form_dlgkbb.vue') },
        // { path: '/form_tyjryb', name:'form_tyjryb', component: () => import('./views/form_2/Form_tyjryb.vue') },
        { path: '/form_danweizp', name:'form_danweizp', component: () => import('./views/form_2/Form_danweizp.vue') },
        { path: '/form_ncldlzyjyhcyqkb', name:'form_ncldlzyjyhcyqkb', component: () => import('./views/form_2/Form_ncldlzyjyhcyqkb.vue') },

        // 工作台账管理系统 - 补贴台账
        { path: '/form_ygdxbttjb', name:'form_ygdxbttjb', component: () => import('./views/form_3/Form_ygdxbttjb.vue') },
        { path: '/form_ycxqzcybttjb', name:'form_ycxqzcybttjb', component: () => import('./views/form_3/Form_ycxqzcybttjb.vue') },
        { path: '/form_jtbttjb', name:'form_jtbttjb', component: () => import('./views/form_3/Form_jtbttjb.vue') },
        { path: '/form_gwsbbttjb', name:'form_gwsbbttjb', component: () => import('./views/form_3/Form_gwsbbttjb.vue') },
        { path: '/form_pxbthshfbt', name:'form_pxbthshfbt', component: () => import('./views/form_3/Form_pxbthshfbt.vue') },
        { path: '/form_btqkztjb', name:'form_btqkztjb', component: () => import('./views/form_3/Form_btqkztjb.vue') },
        
        // 工作台账管理系统 - 其它台账
        { path: '/form_gyxgwaztjb', name:'form_gyxgwaztjb', component: () => import('./views/form_4/Form_gyxgwaztjb.vue') },
        { path: '/form_jyfpcjtjb', name:'form_jyfpcjtjb', component: () => import('./views/form_4/Form_jyfpcjtjb.vue') },
        { path: '/form_rycctjb', name:'form_rycctjb', component: () => import('./views/form_4/Form_rycctjb.vue') },
        { path: '/form_mbrwtjb', name:'form_mbrwtjb', component: () => import('./views/form_4/Form_mbrwtjb.vue') },
        { path: '/form_rlzysczytjb', name:'form_rlzysczytjb', component: () => import('./views/form_4/Form_rlzysczytjb.vue') },
        { path: '/form_nclwjjr', name:'form_nclwjjr', component: () => import('./views/form_4/Form_nclwjjr.vue') },
        { path: '/form_nclwjjrbtsb', name:'form_nclwjjrbtsb', component: () => import('./views/form_4/Form_nclwjjrbtsb.vue') },
        { path: '/form_rlzyfwjg', name:'form_rlzyfwjg', component: () => import('./views/form_4/Form_rlzyfwjg.vue') },
        { path: '/form_rlzyfwjgbtsb', name:'form_rlzyfwjgbtsb', component: () => import('./views/form_4/Form_rlzyfwjgbtsb.vue') },
        { path: '/form_jycyfwbttjb', name:'form_jycyfwbttjb', component: () => import('./views/form_4/Form_jycyfwbttjb.vue') },
        { path: '/form_gwcctjb', name:'form_gwcctjb', component: () => import('./views/form_4/Form_gwcctjb.vue') },
        { path: '/form_czsyrytjb', name:'form_czsyrytjb', component: () => import('./views/form_4/Form_czsyrytjb.vue') },
        
        // 服务日志管理系统
        { path: '/log', name:'log', component: () => import('./views/form_log/log.vue') },
        { path: '/log1', name:'log1', component: () => import('./views/form_log/log1.vue') },
        { path: '/log2', name:'log2', component: () => import('./views/form_log/log2.vue') },
        { path: '/log3', name:'log3', component: () => import('./views/form_log/log3.vue') },
        { path: '/log4', name:'log4', component: () => import('./views/form_log/log4.vue') },
        { path: '/log5', name:'log5', component: () => import('./views/form_log/log5.vue') },
        { path: '/log6', name:'log6', component: () => import('./views/form_log/log6.vue') },
        { path: '/log7', name:'log7', component: () => import('./views/form_log/mylog.vue') },
        { path: '/log_shengcha', name:'log_shengcha', component: () => import('./views/form_log/log_shengcha.vue') },

        // 乡村振兴车间管理
        { path: '/form_jyfpcjjbqkzb', name:'form_jyfpcjjbqkzb', component: () => import('./views/form_bobai/Form_jyfpcjjbqkzb.vue') },
        { path: '/form_jyfpcjxnjymc', name:'form_jyfpcjxnjymc', component: () => import('./views/form_bobai/Form_jyfpcjxnjymc.vue') },
        { path: '/form_jyfpcjdtgl', name:'form_jyfpcjdtgl', component: () => import('./views/form_bobai/Form_jyfpcjdtgl.vue') },
        { path: '/form_xnpkldljydtjgtz', name:'form_xnpkldljydtjgtz', component: () => import('./views/form_bobai/Form_xnpkldljydtjgtz.vue') },
        { path: '/form_xnydbqpkndl', name:'form_xnydbqpkndl', component: () => import('./views/form_bobai/Form_xnydbqpkndl.vue') },

        // 培训服务管理系统
        { path: '/studyUpload', name:'studyUpload', component: () => import('./views/form_study/studyUpload.vue') },
        { path: '/studyApply', name:'studyApply', component: () => import('./views/form_study/studyApply.vue') },
        { path: '/studyExamine', name:'studyExamine', component: () => import('./views/form_study/studyExamine.vue') },
        { path: '/studyList', name:'studyList', component: () => import('./views/form_study/studyList.vue') },

        //招聘求职管理
        { path: '/lookInterview', name:'lookInterview', component: () => import('./views/form_qiuzhi/lookInterview.vue') },
        { path: '/lookResume', name:'lookResume', component: () => import('./views/form_qiuzhi/lookResume.vue') },

        // 企业服务管理系统
        { path: '/companyApply', name:'companyApply', component: () => import('./views/form_falvweiquan/companyApply.vue') },
        { path: '/jiaoyu', name:'jiaoyu', component: () => import('./views/form_chuangye/jiaoyu.vue') },
        { path: '/peixun', name:'peixun', component: () => import('./views/form_chuangye/peixun.vue') },
        { path: '/zhaoshang', name:'zhaoshang', component: () => import('./views/form_chuangye/zhaoshang.vue') },
        { path: '/jiameng', name:'jiameng', component: () => import('./views/form_chuangye/jiameng.vue') },
        { path: '/rongzi', name:'rongzi', component: () => import('./views/form_chuangye/rongzi.vue') },
        { path: '/touzi', name:'touzi', component: () => import('./views/form_chuangye/touzi.vue') },
        { path: '/zufang', name:'zufang', component: () => import('./views/form_chuangye/zufang.vue') },
        { path: '/shoufang', name:'shoufang', component: () => import('./views/form_chuangye/shoufang.vue') },
        { path: '/qiche', name:'qiche', component: () => import('./views/form_chuangye/qiche.vue') },
        { path: '/gouwu', name:'gouwu', component: () => import('./views/form_chuangye/gouwu.vue') },
        { path: '/meishi', name:'meishi', component: () => import('./views/form_chuangye/meishi.vue') },
        { path: '/lvyou', name:'lvyou', component: () => import('./views/form_chuangye/lvyou.vue') },
        { path: '/jiankang', name:'jiankang', component: () => import('./views/form_chuangye/jiankang.vue') },

        // 法律维权管理系统
        { path: '/flzx', name:'flzx', component: () => import('./views/form_falvweiquan/flzx.vue') },
        { path: '/layer', name:'layer', component: () => import('./views/form_falvweiquan/layer.vue') },
        { path: '/layerApply', name:'layerApply', component: () => import('./views/form_falvweiquan/layerApply.vue') },
        { path: '/ajwt', name:'ajwt', component: () => import('./views/form_falvweiquan/ajwt.vue') },

        // 系统设置管理系统 - 系统配置
        { path: '/logo', name:'logo', component: () => import('./views/system/logo.vue') },
        { path: '/mapSet', name:'mapSet', component: () => import('./views/system/mapSet.vue') },
        { path: '/areaedit', name:'areaedit', component: () => import('./views/system/areaEdit.vue') },
        { path: '/setKeyWord', name:'setKeyWord', component: () => import('./views/system/setKeyWord.vue') },
        { path: '/subsite', name:'subsite', component: () => import('./views/system/subsite.vue') },

        // 系统设置管理系统 - 用户设置
        { path: '/fenzhan', name:'fenzhan', component: () => import('./views/system/fenZhan.vue') },
        { path: '/power', name:'power', component: () => import('./views/system/power.vue') },
        { path: '/role', name:'role', component: () => import('./views/system/role.vue') },
        { path: '/vip', name:'vip', component: () => import('./views/system/vip.vue') },

        // 系统设置管理系统 - 链接管理
        { path: '/zhengce', name:'zhengce', component: () => import('./views/system/zhengCe.vue') },
        { path: '/renshe', name:'renshe', component: () => import('./views/system/renshe.vue') },
        { path: '/movie', name:'movie', component: () => import('./views/system/movie.vue') },

        // 系统设置管理系统 - 密码设置
        { path: '/password', name:'password', component: () => import('./views/system/password.vue') },
        { path: '/selfinfo', name:'selfinfo', component: () => import('./views/system/selfInfo.vue') },

         // 信息发布管理系统 - 关于
        { path: '/briefIntroduction', name:'briefIntroduction', component: () => import('./views/form_article/briefIntroduction.vue') },//简介
        { path: '/idea', name:'idea', component: () => import('./views/form_article/idea.vue') },//理念
        { path: '/culture', name:'culture', component: () => import('./views/form_article/culture.vue') },//文化
        { path: '/team', name:'team', component: () => import('./views/form_article/team.vue') },//团队
        { path: '/routeLine', name:'routeLine', component: () => import('./views/form_article/routeLine.vue') },//路线
        { path: '/contactUs', name:'contactUs', component: () => import('./views/form_article/contactUs.vue') },//联系我们
        { path: '/overallArticle', name:'overallArticle', component: () => import('./views/form_article/overallArticle.vue') },//全局文章
        // 信息发布管理系统 - 动态
        { path: '/news', name:'news', component: () => import('./views/form_article/news.vue') },//新闻
        { path: '/activity', name:'activity', component: () => import('./views/form_article/activity.vue') },//活动

        //人事人才管理系统 - 轮播管理
        { path: '/banner_rs', name:'banner_rs', component: () => import('./views/form_rsrc/banner/banner_rs.vue') },//轮播管理
        { path: '/banner_xw', name:'banner_xw', component: () => import('./views/form_rsrc/banner/banner_xw.vue') },//轮播管理
        //人事人才管理系统 - 人事服务
        { path: '/examination', name:'examination', component: () => import('./views/form_rsrc/renshifuwu/examination.vue') },//人事招考
        { path: '/archives', name:'archives', component: () => import('./views/form_rsrc/renshifuwu/archives.vue') },//人事招考
        { path: '/information', name:'information', component: () => import('./views/form_rsrc/renshifuwu/information.vue') },//人事招考
        { path: '/train', name:'train', component: () => import('./views/form_rsrc/renshifuwu/train.vue') },//人事招考
        //人事人才管理系统 - 人才超市
        { path: '/notice', name:'notice', component: () => import('./views/form_rsrc/rencaichaoshi/notice.vue') },//才市预告
        { path: '/scene', name:'scene', component: () => import('./views/form_rsrc/rencaichaoshi/scene.vue') },//现场招聘
        { path: '/video', name:'video', component: () => import('./views/form_rsrc/rencaichaoshi/video.vue') },//视频招聘
        //人事人才管理系统 - 互动交流
        { path: '/interview', name:'interview', component: () => import('./views/form_rsrc/hudongjiaoliu/interview.vue') },//在线访谈
        { path: '/interviewNotice', name:'interviewNotice', component: () => import('./views/form_rsrc/hudongjiaoliu/interviewNotice.vue') },//访谈预告
        { path: '/interviewRecording', name:'interviewRecording', component: () => import('./views/form_rsrc/hudongjiaoliu/interviewRecording.vue') },//访谈录播
        { path: '/knowAll', name:'knowAll', component: () => import('./views/form_rsrc/hudongjiaoliu/knowAll.vue') },//百事通
        { path: '/leaderEmail', name:'leaderEmail', component: () => import('./views/form_rsrc/hudongjiaoliu/leaderEmail.vue') },//领导信箱
        //人事人才管理系统 - 新闻中心
        { path: '/newsCenter', name:'newsCenter', component: () => import('./views/form_rsrc/newsCenter.vue') },//新闻中心

        //个人中心 - 个人信息展示
        { path: '/userInfo', name:'userInfo', component: () => import('./views/form_user/userInfo.vue') },//个人中心
        { path: '/companyInfo', name:'companyInfo', component: () => import('./views/form_user/userInfo.vue') },//个人中心
        { path: '/editPwd', name:'editPwd', component: () => import('./views/system/password.vue') },//账户中心修改密码
        { path: '/sendResume', name:'sendResume', component: () => import('./views/form_user/sendResume.vue') },//发送简历
        { path: '/getInterview', name:'getInterview', component: () => import('./views/form_user/getInterview.vue') },//收到面试
        { path: '/sendInterview', name:'sendInterview', component: () => import('./views/form_user/sendInterview.vue') },//发送的面试邀请
        { path: '/getResume', name:'getResume', component: () => import('./views/form_user/getResume.vue') },//收到的简历
        { path: '/zhan_song_', name:'zhan_song_', component: () => import('./views/form_songjie/zhan_song_.vue') },
        { path: '/zhan_jie_', name:'zhan_jie_', component: () => import('./views/form_songjie/zhan_jie_.vue') },
        { path: '/gongzi', name:'gongzi', component: () => import('./views/form_gongzi/gongzi.vue') },

        // 报表设置管理系统
        { path: '/chart', name:'chart', component: () => import('./views/system/chart.vue') },

        // 投诉建议管理系统
        { path: '/complaint', name:'complaint', component: () => import('./views/form_complaint/complaint.vue') },
        { path: '/communication', name:'communication', component: () => import('./views/form_complaint/communication.vue') },

        // 工作人员服务系统
        { path: '/qiye', name:'qiye', component: () => import('./views/form_qiye/qiye.vue') },
        { path: '/hetong', name:'hetong', component: () => import('./views/form_qiye/hetong.vue') },
        { path: '/fapiao', name:'fapiao', component: () => import('./views/form_qiye/fapiao.vue') },

        // 快速求职管理系统
        // { path: '/quickqiuzhi', name:'quickqiuzhi', component: () => import('./views/form_quickqiuzhi/quickqiuzhi.vue') },
        
        // 工作人员服务系统
        { path: '/shengting_qiye', name:'shengting_qiye', component: () => import('./views/form_shengting/shengting_qiye.vue') },
        { path: '/shengting_gangwei', name:'shengting_gangwei', component: () => import('./views/form_shengting/shengting_gangwei.vue') },
        { path: '/shengting_zhaopinhui', name:'shengting_zhaopinhui', component: () => import('./views/form_shengting/shengting_zhaopinhui.vue') },
        { path: '/shengting_zhaopingangwei', name:'shengting_zhaopingangwei', component: () => import('./views/form_shengting/shengting_zhaopingangwei.vue') },

        // 送站接站服务系统
        { path: '/zhan_song', name:'zhan_song', component: () => import('./views/form_songjie/zhan_song.vue') },
        { path: '/zhan_jie', name:'zhan_jie', component: () => import('./views/form_songjie/zhan_jie.vue') },

        // 个人社保服务系统
        { path: '/shebao_geren', name:'shebao_geren', component: () => import('./views/form_shebao/shebao_geren.vue') },
        { path: '/shebao_weizhuanyi', name:'shebao_weizhuanyi', component: () => import('./views/form_shebao/shebao_weizhuanyi.vue') },
        { path: '/shebao_bujiaofei', name:'shebao_bujiaofei', component: () => import('./views/form_shebao/shebao_bujiaofei.vue') },
        { path: '/shebao_jiaona', name:'shebao_jiaona', component: () => import('./views/form_shebao/shebao_jiaona.vue') },
        { path: '/shebao_tuifei', name:'shebao_tuifei', component: () => import('./views/form_shebao/shebao_tuifei.vue') },

        // 人力资源管理系统
        { path: '/rlzy_guanlian_geren', name:'rlzy_guanlian_geren', component: () => import('./views/form_rlzy/rlzy_guanlian_geren.vue') },
        { path: '/rlzy_guanlian_qiye', name:'rlzy_guanlian_qiye', component: () => import('./views/form_rlzy/rlzy_guanlian_qiye.vue') },
        { path: '/rlzy_dengji_hesuan', name:'rlzy_dengji_hesuan', component: () => import('./views/form_rlzy/rlzy_dengji_hesuan.vue') },
        { path: '/rlzy_dengji_kaipiao', name:'rlzy_dengji_kaipiao', component: () => import('./views/form_rlzy/rlzy_dengji_kaipiao.vue') },
        { path: '/rlzy_dengji_daozhang', name:'rlzy_dengji_daozhang', component: () => import('./views/form_rlzy/rlzy_dengji_daozhang.vue') },

        // 建筑工地管理系统
        { path: '/jzgd_yonggongbeian', name:'jzgd_yonggongbeian', component: () => import('./views/form_jzgd/jzgd_yonggongbeian.vue') },
        { path: '/jzgd_zaixianqiuzhu', name:'jzgd_zaixianqiuzhu', component: () => import('./views/form_jzgd/jzgd_zaixianqiuzhu.vue') },
        { path: '/jzgd_zaixianqiuzhuM', name:'jzgd_zaixianqiuzhuM', component: () => import('./views/form_jzgd/jzgd_zaixianqiuzhuM.vue') },

        // 法律援助管理系统
        { path: '/yz_wt_weituo', name:'yz_wt_weituo', component: () => import('./views/form_falvyuanzhu/yz_wt_weituo.vue') },
        { path: '/yz_wt_fapiao', name:'yz_wt_fapiao', component: () => import('./views/form_falvyuanzhu/yz_wt_fapiao.vue') },
        { path: '/yz_tj_tiaojie', name:'yz_tj_tiaojie', component: () => import('./views/form_falvyuanzhu/yz_tj_tiaojie.vue') },
        { path: '/yz_ss_baoquan', name:'yz_ss_baoquan', component: () => import('./views/form_falvyuanzhu/yz_ss_baoquan.vue') },
        { path: '/yz_ss_qubaohoushen', name:'yz_ss_qubaohoushen', component: () => import('./views/form_falvyuanzhu/yz_ss_qubaohoushen.vue') },
        { path: '/yz_ss_gongzheng', name:'yz_ss_gongzheng', component: () => import('./views/form_falvyuanzhu/yz_ss_gongzheng.vue') },
        { path: '/yz_ss_jinzhan', name:'yz_ss_jinzhan', component: () => import('./views/form_falvyuanzhu/yz_ss_jinzhan.vue') },
        { path: '/yz_ws_zhengju', name:'yz_ws_zhengju', component: () => import('./views/form_falvyuanzhu/yz_ws_zhengju.vue') },
        { path: '/yz_ws_caijue', name:'yz_ws_caijue', component: () => import('./views/form_falvyuanzhu/yz_ws_caijue.vue') },
        { path: '/yz_ws_zongjie', name:'yz_ws_zongjie', component: () => import('./views/form_falvyuanzhu/yz_ws_zongjie.vue') },
        { path: '/yz_ws_guidang', name:'yz_ws_guidang', component: () => import('./views/form_falvyuanzhu/yz_ws_guidang.vue') },

        // 数据统计报表系统
        { path: '/report_rsyw', name:'report_rsyw', component: () => import('./views/form_report/report_rsyw.vue') },
        { path: '/report_grxx', name:'report_grxx', component: () => import('./views/form_report/report_grxx.vue') },
        { path: '/report_grnlwhfx', name:'report_grnlwhfx', component: () => import('./views/form_report/report_grnlwhfx.vue') },
        { path: '/report_grjyfsfx', name:'report_grjyfsfx', component: () => import('./views/form_report/report_grjyfsfx.vue') },
        { path: '/report_grjyqtfx', name:'report_grjyqtfx', component: () => import('./views/form_report/report_grjyqtfx.vue') },
        { path: '/report_grjyqyfx', name:'report_grjyqyfx', component: () => import('./views/form_report/report_grjyqyfx.vue') },
        { path: '/report_dwzpxqfx', name:'report_dwzpxqfx', component: () => import('./views/form_report/report_dwzpxqfx.vue') },
        { path: '/report_gqjgtxfx', name:'report_gqjgtxfx', component: () => import('./views/form_report/report_gqjgtxfx.vue') },

        // 人口进城管理系统
        { path: '/questionnaire_jionCity', name:'questionnaire_jionCity', component: () => import('./views/form_questionnaire/questionnaire_jionCity.vue') },

        // 残疾就业管理系统
        { path: '/canjiren_jynldwjycjrzkdcb', name:'canjiren_jynldwjycjrzkdcb', component: () => import('./views/form_canjiren/canjiren_jynldwjycjrzkdcb.vue') },
        
        // 退役军人管理系统
        { path: '/tuiyijunren_tyjrjyqkcjb', name:'tuiyijunren_tyjrjyqkcjb', component: () => import('./views/form_tuiyijunren/tuiyijunren_tyjrjyqkcjb.vue') },
        { path: '/tuiyijunren_tyjryb', name:'tuiyijunren_tyjryb', component: () => import('./views/form_tuiyijunren/tuiyijunren_tyjryb.vue') },

        // 医疗服务管理系统
        { path: '/yiliaofuwu_bqhf', name:'yiliaofuwu_bqhf', component: () => import('./views/form_yiliaofuwu/yiliaofuwu_bqhf.vue') },
        { path: '/yiliaofuwu_hjtj', name:'yiliaofuwu_hjtj', component: () => import('./views/form_yiliaofuwu/yiliaofuwu_hjtj.vue') },
        { path: '/yiliaofuwu_hjxtpz', name:'yiliaofuwu_hjxtpz', component: () => import('./views/form_yiliaofuwu/yiliaofuwu_hjxtpz.vue') },
        
        { path: '/Template_form', name:'Template_form', component: () => import('./views/Template_form.vue') },
        { path: '/Template', name:'Template', component: () => import('./views/Template.vue') },
      ]
    },
    { path: '/login', name:'login', component: () => import('./views/Login.vue') },
    { path: '/map2', name:'map2', component: () => import('./views/map2.vue') },
    { path: '/map3', name:'map3', component: () => import('./views/map3.vue') },
    { path: '/selfPassword', name:'selfPassword', component: () => import('./views/selfPassword.vue') },


    
    { path: '/show', name:'show', component: () => import('./views/showpage/show.vue') },
    { path: '/home', 
      name:'home',
      redirect:'/fuwu',
      component: () => import('./views/showpage/home.vue'),
      children:[
        { path: '/fuwu', name:'fuwu', component: () => import('./views/showpage/homePage/fuwu.vue'), meta: {x: 0, y: 0} },
        { path: '/detail', name:'detail', component: () => import('./views/showpage/homePage/detail.vue'), meta: {x: 0, y: 0},},
        { path: '/detailList', name:'detailList', component: () => import('./views/showpage/homePage/detailList.vue') },
        { path: '/layerDetail', name:'layerDetail', component: () => import('./views/showpage/homePage/layerDetail.vue') },
        { path: '/recruitDetail', name:'recruitDetail', component: () => import('./views/showpage/homePage/recruitDetail.vue'), meta: {x: 0, y: 0} },
        { path: '/renshi', name:'renshi', component: () => import('./views/showpage/homePage/renshi.vue') },
        { path: '/register', name:'register', component: () => import('./views/showpage/homePage/register.vue'), meta: {x: 0, y: 0} },
        { path: '/renshiNav', name:'renshiNav', component: () => import('./views/showpage/homePage/renshiNav.vue') },
       
        { path: '/article', 
          name:'article', 
          redirect:'/articleDetail',
          component: () => import('./views/showpage/homePage/article.vue'),
          children:[
            { path: '/articleDetail', name:'articleDetail', component: () => import('./views/showpage/homePage/articleDetail.vue') },
            { path: '/articleList', name:'articleList', component: () => import('./views/showpage/homePage/articleList.vue') },
          ]
        },
      ]
    },

    { path: '/agreement', name:'agreement', component: () => import('./views/agreement.vue') },
  ],
  scrollBehavior (to, from, savedPosition) { // 解决vue页面之间跳转，页面不是在顶部的问题
    if(to.path == from.path){
      return null;
    }else{
      return { x: 0, y: 0 }
    }
  }
})
